var map = {
	"./MMBN1/DefaultFoundModifiers.json": 9076,
	"./MMBN2/DefaultFoundModifiers.json": 6729,
	"./MMBN3/DefaultFoundModifiers.json": 1010,
	"./MMBN4/DefaultFoundModifiers.json": 4399,
	"./MMBN5/DefaultFoundModifiers.json": 1384,
	"./MMBN6/DefaultFoundModifiers.json": 4365,
	"./OSS/DefaultFoundModifiers.json": 5390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9186;